import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../assets/Css/login.css";
import { Logo, signIn } from "../../constant/Index";
import { useForm } from "../../hooks/Form";
import { useDispatch, useSelector } from "react-redux";
import { ToastMessage } from "../../utils/ShowToastMessage";
import { setSuccess, clearMessage } from "../../store/reducers/globalReducers";
import { useAuthLoginMutation } from "../../store/services/AuthServices";
import { setUserToken } from "../../store/reducers/AuthReducers";

const Login = () => {
	const [errors, setErrors] = useState([]);
	const { state, onChange } = useForm({
		email: "",
		password: "",
	});
	const dispatch = useDispatch();
	const navigate = useNavigate();
	let { success } = useSelector((state) => state.globalReducer);
	const [userLoginData, response] = useAuthLoginMutation();

	const onSubmit = (e) => {
		e.preventDefault();
		const FormDatas = new FormData();
		FormDatas.append("email", state.email);
		FormDatas.append("password", state.password);
		userLoginData(FormDatas);
		console.log(response, "112212");
	};
	useEffect(() => {
		if (success !== "") {
			ToastMessage(success);
		}
		return () => {
			dispatch(clearMessage());
		};
	}, [success]);

	useEffect(() => {
		if (
			response.isError &&
			response?.error?.data?.message === "Your Email & Password Is Incorrect"
		) {
			ToastMessage(response?.error?.data?.message);
		} else {
			setErrors(response?.error?.data?.errors);
		}
	}, [response?.error?.data]);

	useEffect(() => {
		if (response.isSuccess) {
			setErrors([]);
			localStorage.setItem(
				"userData",
				JSON.stringify(response?.data?.response?.data),
			);
			dispatch(setUserToken(response?.data?.response?.data));
			dispatch(setSuccess(response?.data?.message));
			state.email = "";
			state.password = "";
			// setTimeout(() => {
			// 	navigate("/completeyourprofile");
			// }, 1000);
		}
	}, [response.isSuccess]);
	return (
		<>
			{/* <!-- Sign In Page Start Here --> */}
			<section className="signinSec login p-0">
				<div className="container-fluid">
					<div className="row align-items-center">
						<div className="col-lg-2"></div>
						<div className="col-lg-4 col-md-6 p-0">
							<div className="logo-wrapper">
								<Link to="/">
									<figure>
										<img src={Logo} alt="" />
									</figure>
								</Link>
							</div>
							<div className="signInBox">
								<div className="title">
									<h1>Sign In</h1>
								</div>

								<div className="taglines pb-3">
									<h3>
										Welcome back to <strong>Flit </strong>
										<br />
										Where You can get best<span> E Vehicle services</span>
									</h3>

									<p>
										Not a Member ?<Link to="/signup">Sign Up</Link>
									</p>
								</div>
								<form onSubmit={onSubmit}>
									<div className="form-group">
										<input
											type="email"
											className={`${
												errors && errors?.email
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											name="email"
											value={state.email}
											onChange={onChange}
											placeholder="Email Address"
										/>
									</div>
									{errors && errors?.email && (
										<span className="errorMessage">
											<p>{errors && errors?.email}</p>
										</span>
									)}
									<div className="form-group">
										<input
											type="password"
											placeholder="Password"
											className={`${
												errors && errors?.password
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											name="password"
											value={state.password}
											onChange={onChange}
										/>
									</div>
									{errors && errors?.password && (
										<span className="errorMessage">
											<p>{errors && errors?.password}</p>
										</span>
									)}

									<div className="col-md-12 px-0 text-right mt-3">
										<button
											className="btn btn-secondary btnn signup-btn rounded-pill full"
											type="submit"
										>
											Sign in
										</button>
									</div>
									<div className="actionsLink py-4">
										{/* <div className="remeberDv">
											<div className="form-group">
												<label for="remember" className="custom_check_box">Remember Me
													<input type="checkbox" id="remember" className="remember custom_check_box" hidden />
													<span></span>
												</label>
											</div>
										</div> */}
										<div class="form-group custom_checkbox">
											<input type="checkbox" id="agentcheck1" />
											<label for="agentcheck1" className="ml-0">
												Remember Me
											</label>
										</div>
										<div className="forgotDv">
											<Link to="/ForgotPassword">Forgot Password ?</Link>
										</div>
									</div>
									{/* <div className="privacyDv">
										<p>Copyrights © 2022 Flit. All rights reserved.</p>
									</div> */}
								</form>
							</div>
						</div>

						<div className="col-lg-5 col-md-6 ml-auto p-0">
							<div className="img-Dv">
								<div className="imgBox">
									<figure>
										<img src={signIn} alt="" />
									</figure>
								</div>

								<div className="LogoBox">
									<figure>
										<a href="index.php">
											<img src="img/signinlogo.png" alt="" />
										</a>
									</figure>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <!-- Sign In Page End Here --> */}
		</>
	);
};

export default Login;
